import { courierService } from '@/services';

export const courierModule = {
  namespaced: true,
  state: () => ({
    list:{
      data: null,
      error: null,
    },
  }),
  mutations: {
    load(state) {
      courierService.getCouriers()
      .then((res) => {
        state.list.data = res
      })
      .catch((error) => {
        state.list.data = null
        state.list.error = error
      });
    },
  }
}
